import React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Radio, Typography, Chip, Checkbox, Input } from "@plum-xoxo/admin-dsm";

const OfflinePaymentBackground = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.light.c100};
  border-radius: ${(props) => props.theme.borderRadius.tertiary}px;
  padding: 24px;
`;
const StyledRecommended = styled(Chip).attrs()`
  border: 1px solid ${(props) => props.theme.palette.green.c100};
`;

const CustomMarkerPoints = styled(Typography).attrs()`
  ::marker {
    color: ${(props) => props.theme.palette.orange.c200};
    margin-left: 8px;
  }
`;

const PaymentMethods = ({
  selectedPayment = "payu",
  setPaymentMethod,
  currencyCode = "INR",
  redirectPage = null,
  bankDetails,
  poNumber,
  onChangePONumber,
  kyb_status,
  is_proforma_invoice,
}) => {
  const radioStyle = {
    marginLeft: "-1.5rem",
    marginTop: "1px",
  };
  const nonINRCurrency = currencyCode !== "INR";
  const [poNumberCheckbox, setPoNumberCheckbox] = useState(false);
  const paymentModes = [
    {
      id: 1,
      title: (
        <>
          <Typography.H3
            component="span"
            color={selectedPayment === "online" ? "primary" : "dark"}
            shade={selectedPayment === "online" ? "c02" : "c300"}
          >
            {nonINRCurrency ? "Card Payment" : "Online Transfer"}
          </Typography.H3>
          <StyledRecommended
            backgroundColor="green"
            backgroundShade="c000"
            textColor="green"
            textShade="c300"
            color="custom"
            label={
              <Typography.BodySmall
                className="mb-0 py-4"
                color="green"
                shade="c300"
              >
                Recommended
              </Typography.BodySmall>
            }
            size="small"
            radius={8}
            className="ml-8"
          />
        </>
      ),
      subTitle: (
        <div className="mt-4">
          <Typography color="dark" shade="c200" className="mb-0">
            {nonINRCurrency
              ? "Pay using credit card or debit card."
              : "Pay using Credit Card, Debit Card, Netbanking or UPI."}
          </Typography>
        </div>
      ),
      value: "online",
      show: true,
      message: (
        <>
          <div className="offline-transfers mt-12">
            <ul className="ml-8">
              <CustomMarkerPoints
                className="mb-8"
                component="li"
                color="dark"
                shade="c200"
              >
                {" "}
                Amount will be{" "}
                <Typography component="span" color="dark" shade="c300">
                  instantly credited
                </Typography>{" "}
                to your account.{" "}
              </CustomMarkerPoints>
              <CustomMarkerPoints component="li" color="dark" shade="c200">
                {nonINRCurrency ? (
                  <>
                    {" "}
                    Additional{" "}
                    <Typography component="span" color="dark" shade="c300">
                      surcharge applicable
                    </Typography>{" "}
                    by payment gateway.
                  </>
                ) : (
                  <>
                    {" "}
                    Additional transaction{" "}
                    <Typography component="span" color="dark" shade="c300">
                      {" "}
                      charges applicable{" "}
                    </Typography>{" "}
                    by payment gateway.
                  </>
                )}
              </CustomMarkerPoints>
            </ul>
          </div>
        </>
      ),
    },
    // {
    //   id: 2,
    //   title: "PayPal (Recommended)",
    //   subTitle: "Instantly credited to your account",
    //   value: "paypal",
    //   show: currencyCode !== "INR",
    //   description: {
    //     title: "transaction charges applicable",
    //     list: (
    //       <ul>
    //         <li>
    //           An extra transaction fee of 2% will be charged as processing fee.
    //         </li>
    //         <li>
    //           To avoid transaction charges, please do a direct bank transfer.
    //         </li>
    //       </ul>
    //     ),
    //   },
    // },
  ];
  !redirectPage &&
    kyb_status === 2 &&
    is_proforma_invoice === 0 &&
    paymentModes.push({
      id: 3,
      title: (
        <Typography.H3
          component="span"
          color={selectedPayment === "wireTransfer" ? "primary" : "dark"}
          shade={selectedPayment === "wireTransfer" ? "c02" : "c300"}
        >
          Offline Bank Transfer
        </Typography.H3>
      ),
      subTitle: (
        <span>
            <Typography color="dark" shade="c200" className="mb-0 mt-4">
              Generate an invoice and pay later using NEFT,{" "}
              {bankDetails?.swift_code
                ? "IMPS, RTGS or SWIFT."
                : "IMPS or RTGS."}
            </Typography>
        </span>
      ),
      value: "wireTransfer",
      show: true,
      description: {
            list: (
              <OfflinePaymentBackground className="mt-16">
                <Typography.LabelText
                  color="dark"
                  shade="c200"
                  className="mb-20"
                >
                  USE THIS BANK DETAILS FOR PAYMENT
                </Typography.LabelText>
                {bankDetails?.account_name && (
                  <Typography component="div" className="d-flex m-0">
                    <Typography color="dark" shade="c200" className="mb-2">
                      Account Name:
                    </Typography>
                    <Typography color="dark" shade="c300" className="ml-8 mb-2">
                      {bankDetails?.account_name}
                    </Typography>
                  </Typography>
                )}
                <Typography component="div" className="d-flex">
                  <Typography color="dark" shade="c200" className="mb-2">
                    Bank Name:
                  </Typography>{" "}
                  <Typography color="dark" shade="c300" className="ml-8 mb-2">
                    {bankDetails?.bank_name}
                  </Typography>
                </Typography>
                <Typography component="div" className="d-flex">
                  <Typography color="dark" shade="c200" className="mb-2">
                    Account Number:
                  </Typography>{" "}
                  <Typography color="dark" shade="c300" className="ml-8 mb-2">
                    {bankDetails?.account_no}
                  </Typography>
                </Typography>
                {bankDetails?.ifsc_code && (
                  <Typography component="div" className="d-flex">
                    <Typography color="dark" shade="c200" className="mb-2">
                      IFSC Code:
                    </Typography>{" "}
                    <Typography color="dark" shade="c300" className="ml-8 mb-2">
                      {bankDetails?.ifsc_code}
                    </Typography>
                  </Typography>
                )}
                {bankDetails?.swift_code && (
                  <Typography component="div" className="d-flex">
                    <Typography color="dark" shade="c200" className="mb-2">
                      Swift Code:
                    </Typography>{" "}
                    <Typography color="dark" shade="c300" className="ml-8 mb-2">
                      {bankDetails?.swift_code}
                    </Typography>
                  </Typography>
                )}
                {bankDetails?.sort_code && (
                  <Typography component="div" className="d-flex">
                    <Typography color="dark" shade="c200" className="mb-2">
                      Sort Code:
                    </Typography>{" "}
                    <Typography color="dark" shade="c300" className="ml-8 mb-2">
                      {bankDetails?.sort_code}
                    </Typography>
                  </Typography>
                )}
                {bankDetails?.micr_code && (
                  <Typography component="div" className="d-flex">
                    <Typography color="dark" shade="c200" className="mb-2">
                      MICR Code:
                    </Typography>{" "}
                    <Typography color="dark" shade="c300" className="ml-8 mb-2">
                      {bankDetails?.micr_code}
                    </Typography>
                  </Typography>
                )}
                {bankDetails?.ad_code && (
                  <Typography component="div" className="d-flex">
                    <Typography color="dark" shade="c200" className="mb-2">
                      AD Code:
                    </Typography>{" "}
                    <Typography
                      color="dark"
                      shade="c300"
                      className="ml-8 . mb-2"
                    >
                      {bankDetails?.ad_code}
                    </Typography>
                  </Typography>
                )}
                {bankDetails?.bic_code && (
                  <Typography component="div" className="d-flex">
                    <Typography color="dark" shade="c200" className="mb-2">
                      BIC Code:
                    </Typography>{" "}
                    <Typography color="dark" shade="c300" className="ml-8 mb-2">
                      {bankDetails?.bic_code}
                    </Typography>
                  </Typography>
                )}
                {bankDetails?.branch_code && (
                  <Typography component="div" className="d-flex">
                    <Typography color="dark" shade="c200" className="mb-2">
                      Branch Code:
                    </Typography>{" "}
                    <Typography color="dark" shade="c300" className="ml-8 mb-2">
                      {bankDetails?.branch_code}
                    </Typography>
                  </Typography>
                )}
                {bankDetails?.bank_code && (
                  <Typography component="div" className="d-flex">
                    <Typography color="dark" shade="c200" className="mb-2">
                      Bank Code:
                    </Typography>{" "}
                    <Typography color="dark" shade="c300" className="ml-8 mb-2">
                      {bankDetails?.bank_code}
                    </Typography>
                  </Typography>
                )}
                <Typography.BodySmall
                  color="dark"
                  shade="c200"
                  className="mt-20"
                  component="div"
                >
                  These details are unique to your account. Any transactions
                  will reflect in your wallet balance.
                </Typography.BodySmall>
              </OfflinePaymentBackground>
            ),
            message: (
              <div
                style={{
                  fontSize: "12px",
                  marginTop: "12px",
                }}
                className="font-weight-normal inkLight"
              >
                {bankDetails?.swift_code ? (
                  <>
                    Send your to{" "}
                    <span className="inkNormal">ar@xoxoxday.com</span> on
                    successful payment transfer. We will verify the payment and
                    recharge your account. This may take 1-2 business days.
                  </>
                ) : (
                  ""
                )}
              </div>
            ),
          },
      message: "",
    });

  const handlePaymentSelect = (paymentMode) => {
    // if (paymentMode === "paypal") {
    //   initiatePaypal();
    // }
    setPaymentMethod(paymentMode);
  };
  return (
    <div
      className={`paymentMethods ${is_proforma_invoice === 0 ? "mt-4" : ""}`}
    >
      <Typography.H2 color="dark" shade="c300" className="mb-10">
        Select payment method
      </Typography.H2>

      {paymentModes.map((mode, index) => {
        if (mode.show) {
          return (
            <div
              key={mode.id}
              className={`paymentMethod ${
                is_proforma_invoice === 0 ? "mt-24" : "pt-0"
              }`}
            >
              <Radio
                checked={selectedPayment === mode.value}
                onChange={(e) => {
                  handlePaymentSelect(e.target.value);
                }}
                value={mode.value}
                label={mode.title}
                description={mode.subTitle}
              />
              <div className="ml-2">
                {mode.value === selectedPayment && <div>{mode.message}</div>}
              </div>
              {mode.value === selectedPayment && mode.description ? (
                <>
                  <div className="ml-2 offline_payment mr-36 ml-26">
                    <div className="title inkLight">
                      {mode.description.title}
                    </div>
                    {mode.description.list}
                    {mode.description.message}
                  </div>
                  <div className="ml-2 mt-12 mr-36 ml-26 d-flex flex-column">
                    <div>
                      <Checkbox
                        value={poNumberCheckbox}
                        onChange={() => setPoNumberCheckbox(!poNumberCheckbox)}
                        label={
                          <Typography component="div" color="dark" shade="c200">
                            Add purchase order or reference number (optional)
                          </Typography>
                        }
                      />
                    </div>

                    <div>
                      {poNumberCheckbox && (
                        <div className="mt-8 ml-36">
                          <Input
                            value={poNumber}
                            onChange={(e) => onChangePONumber(e)}
                            type="text"
                            placeholder="Enter number here"
                            helperText="This number will be printed on your invoice for your
                            internal record."
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : null}
              {index < paymentModes.length - 1 && <hr className="my-24" />}
            </div>
          );
        }
      })}
    </div>
  );
};

export default PaymentMethods;
